<section id="parceiros" class="partners_container">
    <div class="container partners_content">
        <h1>Nossos Parceiros</h1>
        <p class="p-desc">
            Juntos, tornamos grandes causas possíveis. Colaboramos com organizações,
            empresas e instituições que acreditam no poder da solidariedade e da
            inovação social
        </p>

        <div class="list_partners">
            <div class="partner_item" *ngFor="let item of partners">
                <img [src]="item.photo" [alt]="item.tooltip" [pTooltip]="item.tooltip" />
            </div>
        </div>
    </div>
</section>